/**
 * m1v2-sticky-bar.js
 * Show fixed Reserve bar after the m1v2 hero scrolls out of view
 * (same IntersectionObserver pattern as sectionm1-hero sticky CTA).
 */
(function () {
  function init(root) {
    if (!root || root.dataset.m1v2StickyInit === '1') return;
    root.dataset.m1v2StickyInit = '1';

    root.removeAttribute('hidden');

    var observeTarget =
      document.getElementById('hero') ||
      document.querySelector('.m1v2-hero .hero-a1') ||
      document.querySelector('.m1v2-hero');

    if (!observeTarget || !('IntersectionObserver' in window)) {
      root.classList.add('is-visible');
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          root.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0, rootMargin: '0px' }
    );

    io.observe(observeTarget);
  }

  function boot() {
    document.querySelectorAll('[data-m1v2-sticky-bar]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    var bar = section.querySelector('[data-m1v2-sticky-bar]');
    if (bar) init(bar);
  });
})();
